import React from 'react';
import PropTypes from 'prop-types';

import { FieldLabel } from '../css';

const FieldTitle = ({ required, label }) => {
  return (
    <>
      <FieldLabel>
        {label}
        {required && ` *`}
      </FieldLabel>
    </>
  );
};

FieldTitle.propTypes = {
  required: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired
};

export default FieldTitle;
